import { isSectionValid } from 'containers/PropertyAssessment/selectors';
import {
  NON_SAVEABLE_SECTIONS,
  STATUS,
} from 'containers/PropertyAssessment/constants';
import { createSectionVisibilityMap } from 'containers/PropertyAssessment/data/propertyAssessment';

import { SECTIONS_TYPE } from './constants';

export const getProgress = ({ checklist, assessment }) => {
  const progress = {
    total: 0,
    current: 0,
  };

  if (!checklist) {
    return progress;
  }

  const mappableSectionTypes = [
    SECTIONS_TYPE.HOUSE,
    SECTIONS_TYPE.EXTERNAL_AREA,
  ];
  const visibilityMap = createSectionVisibilityMap({ checklist, assessment });

  if (assessment) {
    const sections = Object.values(assessment.sections)
      .filter((section) => Object.keys(section.items).length > 0)
      .filter((section) => !NON_SAVEABLE_SECTIONS.includes(section.id))
      .filter((section) =>
        section.id in visibilityMap ? visibilityMap[section.id] : true,
      );

    const validSections = sections.filter((section) =>
      isSectionValid(assessment, section),
    );

    progress.total +=
      assessment.status === STATUS.COMPLETED ? 0 : sections.length;
    progress.current +=
      assessment.status === STATUS.COMPLETED ? 0 : validSections.length;
  } else {
    mappableSectionTypes.push(SECTIONS_TYPE.GENERAL_CONDITIONS);
  }

  const mappableSections = Object.keys(checklist).filter((sectionSlug) =>
    mappableSectionTypes.includes(sectionSlug),
  );
  mappableSections.forEach((sectionTypeKey) => {
    const sectionType = checklist[sectionTypeKey];
    const sections = Object.keys(sectionType);

    sections.forEach((sectionKey) => {
      const section = sectionType[sectionKey];
      const sectionItems = Object.keys(section.items).filter(
        (key) => !section.items[key].optional,
      );
      progress.total += sectionItems.length;
      const sumSectionItems = (sumOfItems, itemKey) =>
        section.items[itemKey].value !== undefined
          ? sumOfItems + 1
          : sumOfItems;
      progress.current += sectionItems.reduce(sumSectionItems, 0);
    });
  });

  return progress;
};

export const checkIfChecklistIsComplete = ({ checklist, assessment }) => {
  const progress = getProgress({
    checklist,
    assessment,
  });
  return (
    progress.total !== 0 &&
    progress.total === progress.current &&
    checklist?.fixed?.house?.items?.tipo?.value !== undefined
  );
};

export const isSectionFinished = ({ checklist, sectionTypeName }) => {
  if (!checklist) {
    return false;
  }

  const progress = {
    total: 0,
    current: 0,
  };

  const mappableSectionTypes = [sectionTypeName];
  const mappableSections = Object.keys(checklist).filter((sectionSlug) =>
    mappableSectionTypes.includes(sectionSlug),
  );
  mappableSections.forEach((sectionTypeKey) => {
    const sectionType = checklist[sectionTypeKey];
    const sections = Object.keys(sectionType);

    sections.forEach((sectionKey) => {
      const section = sectionType[sectionKey];
      const sectionItems = Object.keys(section.items).filter(
        (key) => !section.items[key].optional,
      );
      progress.total += sectionItems.length;
      const sumSectionItems = (sumOfItems, itemKey) =>
        section.items[itemKey].value !== undefined
          ? sumOfItems + 1
          : sumOfItems;
      progress.current += sectionItems.reduce(sumSectionItems, 0);
    });
  });

  return progress.total === progress.current;
};
